import request from '@/utils/request'
import store from '@/store'
import _g from '../../src/global'

const PenilaianService = {
  getValidasiCalendar,
  getValidasiTampil,
  validasiAktivitasTerima,
  validasiAktivitasTolak,
  konversiAngkaKreditV2,
  konversiAngkaKredit
}

function konversiAngkaKreditV2(triwulan = 0){
  let current = store.state.user.current;
  let baseUrl = _g.getBaseURLAPIERK(current.year, `v2/export/angka-kredit?nip=${current.username}`);

  if(triwulan > 0){
    baseUrl = baseUrl + `&triwulan=${triwulan}`
  }

  return request({
      url: baseUrl,
      method: "GET"
  });
}

function konversiAngkaKredit(triwulan) {
  let current = store.state.user.current;
  let baseUrl = _g.getBaseURLAPIERK(current.year, `v1/export-data-konversi-nilai-angka-kredit`);

  return request({
      url: baseUrl,
      method: "POST",
      data: {
        api: 1,
        nip: current.username,
        triwulan: triwulan == 0 ? 'tahun' : triwulan,
      }
  });
}

function getValidasiCalendar({from, to}){
  let current = store.state.user.current
  let user = store.state.user
  if(user.current.role.includes("PLT") || user.current.role.includes("Kepala UPT Puskesmas") || user.current.role.includes("PLH")){
    current.username = _g.overrideWithPLT(user.current.role)
  }else{
    current.username = user.current.username
  }
  return request({
    url: '/get-value-validasi-aktivitas-calendar',
    method: 'post',
    data: {
      nip: current.username,
      from: from,
      to: to
    }
  })
}

function getValidasiTampil(tanggal, jenis){
  let current = store.state.user.current
  let user = store.state.user
  if(user.current.role.includes("PLT") || user.current.role.includes("Kepala UPT Puskesmas") || user.current.role.includes("PLH")){
    current.username = _g.overrideWithPLT(user.current.role)
  }else{
    current.username = user.current.username
  }
  return request({
    url: '/get-validasi-aktivitas-tampil',
    method: 'post',
    data: {
      nip: current.username,
      tanggal: tanggal,
      jenis: jenis
    }
  })
}


function validasiAktivitasTerima(id,ket,nip_bawahan){
  let current = store.state.user.current
  let user = store.state.user
  if(user.current.role.includes("PLT") || user.current.role.includes("Kepala UPT Puskesmas") || user.current.role.includes("PLH")){
    current.username = _g.overrideWithPLT(user.current.role)
  }else{
    current.username = user.current.username
  }
  return request({
    url:'/validasi-aktivitas-terima-validasi-aktivitas',
    method: 'post',
    data:{
      nip : current.username,
      "id": id,
      "nip_bawahan": nip_bawahan,
      "valid": "valid",
      "role": "valid",
      "keterangan_valid": ket
    }
  })
}


function validasiAktivitasTolak(id,ket,nip_bawahan){
  let current = store.state.user.current
  let user = store.state.user
  if(user.current.role.includes("PLT") || user.current.role.includes("Kepala UPT Puskesmas") || user.current.role.includes("PLH")){
    current.username = _g.overrideWithPLT(user.current.role)
  }else{
    current.username = user.current.username
  }
  return request({
    url:'/validasi-aktivitas-tolak-validasi-aktivitas',
    method: 'post',
    data:{
      nip : current.username,
      "id": id,
      "nip_bawahan": nip_bawahan,
      "valid": "invalid",
      "role": "valid",
      "keterangan_valid": ket
    }
  })
}

export default PenilaianService
